import * as React from 'react';
import styled from 'styled-components/macro';

import zeemee from './icons/zeemee.png';
import instagram from './icons/instagram.png';
import bni from './icons/bni.png';
import cars from './icons/carscom.png';
import dealerReater from './icons/dealerreater.png';
import edmunds from './icons/edmunds.png';
import linkedIn from './icons/linkedin.png';
import tikTok from './icons/tiktok.png';
import twitter from './icons/twitter_new.png';
import whatsapp from './icons/whatsapp.png';
import youtube from './icons/youtube.png';
import yelp from './icons/yelp.png';
import pinterest from './icons/pinterest.png';
import facebook from './icons/facebook.png';

interface Props {
  className?: string;
  src?: string;
  alt?: string;
  commonStyles?: any;
  extendStyles?: { container?: React.CSSProperties };
}
type IconContainerProps = {
  bgColor?: string;
  margin?: string;
  onClick?: any;
};

const IconContainer = styled.div<IconContainerProps>`
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  margin: ${props => props.margin || 0};
  padding: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: black;
`;

export const FacebookIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const InstagramIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const LinkedinIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const YoutubeIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const TwitterIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const YelpIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const TiktokIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const ZeeMeeIcon = (props: Props) => {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const EdmundsIcon = function (props: Props) {
  return (
    <IconContainer
      bgColor={'#007ee5'}
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const BNIIcon = function (props: Props) {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const CarsDotComIcon = function (props: Props) {
  return (
    <IconContainer
      bgColor={'#652399'}
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const DealerRaterIcon = function (props: Props) {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const WhatsappIcon = function (props: Props) {
  return (
    <IconContainer
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const PinterestIcon = function (props: Props) {
  return (
    <IconContainer
      bgColor={'#E60023'}
      margin={'7.5px 10px 7.5px 10px;'}
      className={props.className || ''}
      style={props?.extendStyles?.container}
    >
      <img src={props.src} alt={props.alt} style={props.commonStyles} />
    </IconContainer>
  );
};

export const getSocialIconObject = (
  className: string,
  extendStyles?: { container?: React.CSSProperties }
) => {
  const commonStyles = {
    maxWidth: '40px',
    maxHeight: '40px',
    borderRadius: `${className === 'circularShape' ? '20px' : '4px'}`,
    cursor: 'pointer',
  };
  return {
    facebook: (
      <FacebookIcon
        className={className}
        src={facebook}
        alt={'Facebook icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    twitter: (
      <TwitterIcon
        className={className}
        src={twitter}
        alt={'Twitter icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    linkedIn: (
      <LinkedinIcon
        className={className}
        src={linkedIn}
        alt={'LinkedIn icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    youtube: (
      <YoutubeIcon
        className={className}
        src={youtube}
        alt={'Youtube icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    instagram: (
      <InstagramIcon
        className={className}
        src={instagram}
        alt={'Instagram icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    yelp: (
      <YelpIcon
        className={className}
        src={yelp}
        alt={'Yelp icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    edmunds: (
      <EdmundsIcon
        className={className}
        src={edmunds}
        alt={'Edmunds icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    carsdotcom: (
      <CarsDotComIcon
        className={className}
        src={cars}
        alt={'CarsDotCom icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    dealerRater: (
      <DealerRaterIcon
        className={className}
        src={dealerReater}
        alt={'Dealer Rater icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    bni: (
      <BNIIcon
        className={className}
        src={bni}
        alt={'BNI icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    tikTok: (
      <TiktokIcon
        className={className}
        src={tikTok}
        alt={'TikTok icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    zeemee: (
      <ZeeMeeIcon
        className={className}
        src={zeemee}
        alt={'ZeeMee icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    whatsApp: (
      <WhatsappIcon
        className={className}
        src={whatsapp}
        alt={'Whatsapp icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
    pinterest: (
      <PinterestIcon
        className={className}
        src={pinterest}
        alt={'Pinterest icon'}
        commonStyles={commonStyles}
        extendStyles={extendStyles}
      />
    ),
  };
};
